import { __assign } from "tslib";
import React from 'react';
import cx from 'classnames';
import bcx from 'bem-classname';
import { Modal as ROModal } from 'react-overlays';
import { IconButton } from '../IconButton';
import { Close } from '../icons';
var renderBackdrop = function (props) {
    var componentClass = 'icon-modal';
    return React.createElement("div", __assign({}, props, { className: bcx(componentClass, 'backdrop') }));
};
export var IconModalBody = function (props) {
    var _a = props.componentClass, componentClass = _a === void 0 ? 'icon-modal' : _a, className = props.className, children = props.children, title = props.title, icon = props.icon;
    var classes = cx(bcx(componentClass, 'body'), className);
    return (React.createElement("div", { className: classes },
        icon && (React.createElement("div", { className: bcx(componentClass, 'icon') }, React.cloneElement(icon, { size: 32 }))),
        React.createElement("h3", { className: cx(bcx(componentClass, 'title'), 'text--uppercase') }, title),
        children));
};
IconModalBody.defaultProps = {
    componentClass: undefined,
    className: '',
};
export var IconModalActions = function (props) {
    var _a = props.componentClass, componentClass = _a === void 0 ? 'icon-modal' : _a, className = props.className, children = props.children;
    var classes = cx(bcx(componentClass, 'actions'), className);
    return React.createElement("div", { className: classes }, children);
};
IconModalActions.defaultProps = {
    componentClass: undefined,
    className: '',
};
export var IconModal = function (props) {
    var show = props.show, modalClose = props.modalClose, children = props.children, className = props.className, fullHeight = props.fullHeight, id = props.id, dataTestid = props["data-testid"];
    var componentClass = 'icon-modal';
    var classes = cx(bcx(componentClass, {
        'full-height': fullHeight,
    }), componentClass, className);
    return (React.createElement(ROModal, { onHide: modalClose, className: classes, id: id, show: show, renderBackdrop: renderBackdrop },
        React.createElement("div", { className: "icon-modal__dialog", "data-testid": dataTestid },
            React.createElement("div", { className: "icon-modal__content" },
                React.createElement("div", { className: "icon-modal__header" }, modalClose && (React.createElement(IconButton, { icon: React.createElement(Close, null), variant: "primary", onClick: modalClose, size: "sm", "data-testid": "modal-close-button" }))),
                children))));
};
IconModal.defaultProps = {
    className: '',
    id: null,
    fullHeight: false,
    modalClose: undefined,
    'data-testid': undefined,
};
IconModalBody.defaultProps = {
    icon: undefined,
};
IconModal.Body = IconModalBody;
IconModal.Actions = IconModalActions;
//# sourceMappingURL=IconModal.js.map